const en = {
  // ─── Common ───
  lang: 'en',
  langLabel: 'English',

  // ─── Free Kundli Page ───
  freeKundli: {
    title: 'Free Kundli',
    subtitle: 'Generate your Vedic birth chart with Dasha, Yogas, Doshas & Panchanga',
    enterBirthDetails: 'Enter Birth Details',
    name: 'Name',
    namePlaceholder: 'Enter your name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    dob: 'Date of Birth',
    tob: 'Time of Birth',
    hour: 'Hour',
    minute: 'Minute',
    pob: 'Place of Birth',
    placePlaceholder: 'Start typing a city name...',
    ayanamsaSystem: 'Ayanamsa System',
    includeAll: 'Include Dasha, Yogas, Doshas & Panchanga',
    generating: 'Generating...',
    generateKundli: 'Generate Chart',
    matchingLink: 'Horoscope Matching (Gun Milan)',
    panchangamLink: "Today's Panchangam",
    noChartTitle: 'No chart generated yet',
    noChartDesc: 'Fill in your birth details and click "Generate Chart" to see your birth chart',
    errSelectPlace: 'Please select a place from the suggestions to get coordinates.',
    errInvalidDob: 'Please enter a valid date of birth.',

    // Tabs
    tabChart: 'Chart & Planets',
    tabDasha: 'Dasha',
    tabYogas: 'Yogas',
    tabDoshas: 'Doshas',
    tabPanchanga: 'Panchanga',
    tabShadbala: 'Shadbala',
    tabAshtakavarga: 'Ashtakavarga',
    tabVargas: 'Divisional Charts',
    tabHouses: 'Houses',
    tabBhavaBala: 'Bhava Bala',
    tabVimshopaka: 'Vimshopaka',

    // Chart Tab
    rasiChakra: 'Rasi Chakra',
    navamsaChakra: 'Navamsa Chakra',
    planetDetails: 'Planet Details',
    colPlanet: 'Planet',
    colSign: 'Sign',
    colDegree: 'Degree',
    colNakshatra: 'Nakshatra',
    colPada: 'Pada',
    colNavamsa: 'Navamsa',
    colRetro: 'Retro',
    birthDetails: 'Birth Details',
    labelName: 'Name',
    labelGender: 'Gender',
    labelDate: 'Date',
    labelTime: 'Time',
    labelPlace: 'Place',
    labelAyanamsa: 'Ayanamsa',

    // Dasha Tab
    vimshottariDasha: 'Vimshottari Dasha',
    currentlyRunning: 'Currently Running',
    mahadasha: 'Mahadasha',
    antardasha: 'Antardasha',
    pratyantdasha: 'Pratyantdasha',
    birthDashaLord: 'Birth Dasha Lord',
    balanceAtBirth: 'Balance at Birth',
    moonNakshatra: 'Moon Nakshatra',
    yrs: 'yrs',
    years: 'years',
    yrsUnit: 'Y',
    monthsUnit: 'M',
    daysUnit: 'D',
    mahadashaPeriods: 'Mahadasha Periods',
    bukthi: 'Bukthi',
    anthara: 'Anthara',
    sukshuma: 'Sukshuma',
    prana: 'Prana',
    dashaClickHint: 'Click a Mahadasha to see Bukthi periods',
    clickForAnthara: 'Click to see Anthara periods',
    clickForSukshuma: 'Click to see Sukshuma periods',
    clickForPrana: 'Click to see Prana periods',

    // Yogas Tab
    yogasFound: 'Yogas Found',
    noYogas: 'No significant yogas detected in this chart.',

    // Doshas Tab
    doshaAnalysis: 'Dosha Analysis',
    present: 'PRESENT',
    notPresent: 'NOT PRESENT',
    cancellations: 'Cancellations',
    remedies: 'Remedies',

    // Panchanga Tab
    panchangaTitle: 'Panchanga (Five Limbs)',
    tithi: 'Tithi',
    vara: 'Vara (Day)',
    nakshatra: 'Nakshatra',
    yoga: 'Yoga',
    karana: 'Karana',
    paksha: 'Paksha',
    lord: 'Lord',
  },

  // ─── Kundli Matching Page ───
  matching: {
    backToKundli: 'Back to Free Kundli',
    title: 'Horoscope Matching',
    subtitle: 'Ashtakoot Gun Milan - Marriage Compatibility Analysis',
    brideDetails: "Girl's Birth Details",
    groomDetails: "Boy's Birth Details",
    dob: 'Date of Birth',
    tob: 'Time of Birth',
    hour: 'Hour',
    minute: 'Minute',
    pob: 'Place of Birth',
    placePlaceholder: 'Start typing a city...',
    calculating: 'Calculating Compatibility...',
    calculateMatching: 'Calculate Matching',
    errSelectPlace: 'Please select a place from the suggestions for both girl and boy.',
    errInvalidDob: 'Please enter valid dates of birth.',

    // Results
    kootaBreakdown: 'Koota Breakdown',
    mangalCrossCheck: 'Mangal Dosha Cross-Check',
    bride: 'Girl',
    groom: 'Boy',
    manglik: 'Manglik',
    nonManglik: 'Non-Manglik',
    compatible: 'Compatible',
    mismatch: 'Mismatch (consult an astrologer for cancellation conditions)',
    recommendations: 'Recommendations',
    brideChart: "Girl's Chart",
    groomChart: "Boy's Chart",
  },

  // ─── Koota Descriptions ───
  kootas: {
    Varna: 'Spiritual compatibility & ego levels',
    Vashya: 'Mutual attraction & dominance',
    Tara: 'Health and destiny compatibility',
    Yoni: 'Physical and sexual compatibility',
    'Graha Maitri': 'Mental & intellectual compatibility',
    Gana: 'Temperament and nature matching',
    Bhakoot: 'Emotional and financial compatibility',
    Nadi: 'Health, genes & progeny compatibility',
  },

  // ─── Planet Names ───
  planets: {
    Ascendant: 'Ascendant',
    Sun: 'Sun',
    Moon: 'Moon',
    Mars: 'Mars',
    Mercury: 'Mercury',
    Jupiter: 'Jupiter',
    Venus: 'Venus',
    Saturn: 'Saturn',
    Rahu: 'Rahu',
    Ketu: 'Ketu',
  },

  // ─── Sign Names ───
  signs: {
    Aries: 'Aries',
    Taurus: 'Taurus',
    Gemini: 'Gemini',
    Cancer: 'Cancer',
    Leo: 'Leo',
    Virgo: 'Virgo',
    Libra: 'Libra',
    Scorpio: 'Scorpio',
    Sagittarius: 'Sagittarius',
    Capricorn: 'Capricorn',
    Aquarius: 'Aquarius',
    Pisces: 'Pisces',
  },

  // ─── Nakshatra Names ───
  nakshatras: {
    'Ashwini': 'Ashwini',
    'Bharani': 'Bharani',
    'Krittika': 'Krittika',
    'Rohini': 'Rohini',
    'Mrigashira': 'Mrigashira',
    'Ardra': 'Ardra',
    'Punarvasu': 'Punarvasu',
    'Pushya': 'Pushya',
    'Ashlesha': 'Ashlesha',
    'Magha': 'Magha',
    'Purva Phalguni': 'Purva Phalguni',
    'Uttara Phalguni': 'Uttara Phalguni',
    'Hasta': 'Hasta',
    'Chitra': 'Chitra',
    'Swati': 'Swati',
    'Vishakha': 'Vishakha',
    'Anuradha': 'Anuradha',
    'Jyeshtha': 'Jyeshtha',
    'Moola': 'Moola',
    'Purva Ashadha': 'Purva Ashadha',
    'Uttara Ashadha': 'Uttara Ashadha',
    'Shravana': 'Shravana',
    'Dhanishta': 'Dhanishta',
    'Shatabhisha': 'Shatabhisha',
    'Purva Bhadrapada': 'Purva Bhadrapada',
    'Uttara Bhadrapada': 'Uttara Bhadrapada',
    'Revati': 'Revati',
  },

  // ─── Sign Abbreviations (for chart cells) ───
  signAbbrevs: ['Ari', 'Tau', 'Gem', 'Can', 'Leo', 'Vir', 'Lib', 'Sco', 'Sag', 'Cap', 'Aqu', 'Pis'],

  // ─── Ascendant abbreviation ───
  ascAbbrev: 'Asc',

  // ─── Yoga Strength ───
  yogaStrength: {
    'very strong': 'very strong',
    'strong': 'strong',
    'moderate': 'moderate',
    'weak': 'weak',
  },

  // ─── Dosha Names (passthrough for English) ───
  doshaNames: {},
  doshaDescriptions: {},
  doshaRemedies: {},
  yogaNames: {},
  yogaSanskrit: {},
  yogaDescriptions: {},

  // ─── Dosha Severity ───
  doshaSeverity: {
    'high': 'HIGH',
    'medium': 'MEDIUM',
    'low': 'LOW',
    'cancelled': 'CANCELLED',
    'none': 'NONE',
  },

  // ─── Panchanga lookups (passthrough for English) ───
  tithiNames: {},
  pakshaNames: {},
  varaNames: {},
  panchangaYogaNames: {},
  karanaNames: {},

  // ─── Daily Balance (KalaShakti) ───
  dailyBalanceTitle: 'KalaShakti Daily Balance',
  dailyBalanceSubtitle: 'Your personalized daily planetary strength based on Ashtakavarga',
  computeBalance: 'Compute Daily Balance',
  computing: 'Computing...',
  whatIsKalaShakti: 'What is KalaShakti?',
  kalaShaktiDesc: 'KalaShakti Daily Balance combines your birth chart\'s Ashtakavarga data with current planetary transits to give you a personalized daily score (0-100). It tells you WHAT is happening, WHY it affects you, WHERE in your life, WHEN the effect is strongest, and WHAT TO DO about it.',
  scoreComponents: 'Score Components',
  tabHighlights: 'Highlights',
  tabPlanets: 'Planet Reports',
  tabSky: 'Current Sky',
  tabHourly: 'Hourly Timeline',
  strength: 'Strength',
  caution: 'Caution',
  lifeArea: 'Life Area',
  transitSign: 'Transit Sign',
  kakshya: 'Kakshya',
  house: 'House',
  currentSky: 'Current Sky',
  hourlyTimeline: 'Hourly Timeline',
  bestWindow: 'Best Window',
  newChart: 'New Chart',
  targetDate: 'Target Date',

  // ─── Vedic Shared Forms ───
  vedic: {
    forms: {
      name: 'Name',
      namePlaceholder: 'Enter name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      dob: 'Date of Birth',
      tob: 'Time of Birth',
      hour: 'Hour',
      minute: 'Minute',
      am: 'AM',
      pm: 'PM',
      timeFormat: 'Time Format',
      format12h: '12 Hour',
      format24h: '24 Hour',
      place: 'Place of Birth',
      placePlaceholder: 'Type a place name...',
      locationLabel: 'Location',
      ayanamsa: 'Ayanamsa System',
      date: 'Date',
      generate: 'Generate',
      compute: 'Compute',
      calculate: 'Calculate',
      loading: 'Computing...',
      submit: 'Submit',
      errSelectPlace: 'Please select a place from suggestions',
      errInvalidDob: 'Please enter a valid date of birth',
      errInvalidTime: 'Please enter a valid time',
      timezone: 'Timezone',
      detecting: 'Detecting timezone...',
      useRecentData: 'Birth data from your last session is available.',
      useIt: 'Use it',
      dismiss: 'Dismiss',
      chartStyle: 'Chart Style',
      southIndian: 'South Indian',
      northIndian: 'North Indian',
    },
  },

  // ─── Panchangam Page ───
  panchangam: {
    pageTitle: "Today's Panchangam",
    pageSubtitle: 'Daily Panchanga with timings and auspicious periods',
    sections: {
      fiveLimbs: 'Pancha Anga (Five Limbs)',
      sunMoon: 'Sun & Moon',
      auspicious: 'Auspicious & Inauspicious Periods',
      gowri: 'Gowri Panchangam',
      gowriDay: 'Day (Pagal)',
      gowriNight: 'Night (Iravu)',
    },
    date: {
      today: 'Today',
      prevDay: 'Previous day',
      nextDay: 'Next day',
      openCalendar: 'Open calendar',
    },
    ayanamsa: {
      label: 'Ayanamsa',
      lahiri: 'Lahiri',
      kp: 'KP (Krishnamurti)',
      raman: 'Raman',
      true_chitra: 'True Chitra',
    },
    nature: {
      auspicious: 'Auspicious',
      inauspicious: 'Inauspicious',
      neutral: 'Neutral',
    },
    periods: {
      rahuKaal: 'Rahu Kaal',
      yamagandam: 'Yamagandam',
      gulikai: 'Gulikai',
      nallaNeram: 'Nalla Neram',
      abhijitMuhurta: 'Abhijit Muhurta',
      brahmaMuhurta: 'Brahma Muhurta',
      amritKalam: 'Amrit Kalam',
      durMuhurtam: 'Dur Muhurtam',
      varjyam: 'Varjyam',
    },
    sun: {
      sunrise: 'Sunrise',
      sunset: 'Sunset',
      moonrise: 'Moonrise',
      moonset: 'Moonset',
      dinamana: 'Dinamana (Day length)',
      ratrimana: 'Ratrimana (Night length)',
    },
    festival: {
      label: 'Festival',
    },
  },

  // ─── Siddhanta Selector ───
  siddhanta: {
    label: 'Siddhanta',
    drik: 'Thirukanitha (Drik)',
    vakyam: 'Vakyam (Surya Siddhanta)',
    compare: 'Compare Both',
    badge: {
      drik: 'Thirukanitha (Drik) \u00b7 திருக்கணிதம்',
      vakyam: 'Vakyam (Surya Siddhanta) \u00b7 வாக்கியம்',
    },
    ayanamsaDisabledTooltip: 'Vakyam uses its traditional Surya Siddhanta ayanamsa',
  },

  // ─── Drik vs Vakyam Comparison ───
  comparison: {
    agreement: {
      high: 'High agreement \u2014 both siddhantas match closely',
      partial: 'Partial agreement \u2014 some differences today',
      low: 'Low agreement \u2014 significant differences today',
    },
    fields: {
      sunrise: 'Sunrise',
      sunset: 'Sunset',
      tithi: 'Tithi',
      nakshatra: 'Nakshatra',
      yoga: 'Yoga',
      karana: 'Karana',
      tamil_yogam: 'Tamil Yogam',
      rahu_kaal: 'Rahu Kaal',
    },
    header: {
      drik: 'Thirukanitha (Drik)',
      vakyam: 'Vakyam (Surya Siddhanta)',
      delta: 'Delta',
    },
    match: {
      yes: 'Names match',
      no: 'Names differ',
    },
    festival: {
      both_same_date: 'Both agree',
      different_date: 'Different dates',
      drik_only: 'Thirukanitha only',
      vakyam_only: 'Vakyam only',
    },
    educational: {
      title: 'Why do these differ?',
      body: 'Thirukanitha (Drik Ganita) uses NASA JPL DE431 ephemeris with modern astronomical models. Vakyam uses traditional Surya Siddhanta formulas (~1500 CE). Both are valid traditions. Major temples in Kanchipuram and Srirangam follow Vakyam; most printed Tamil panchangams use Thirukanitha. Your local temple\'s panchangam may follow either.',
      deltaNote: 'Delta = Vakyam \u2212 Thirukanitha. Positive means Vakyam is later.',
    },
    detailed: {
      expand: 'Show full panchangam for both siddhantas',
      collapse: 'Hide full panchangam',
      drikHeading: 'Thirukanitha (Drik)',
      vakyamHeading: 'Vakyam (Surya Siddhanta)',
    },
  },

  // ─── Rama Shalaka Prashnavali ───
  ramaShalaka: {
    titleEn: 'Sri Rama Shalaka Prashnavali',
    titleTa: 'Sri Rama Shalaka Prashnavali',
    invitation: "Hold a question in your heart and seek Sri Rama's blessing",
    instruction1: 'Close your eyes and focus on your question',
    instruction2: 'When ready, tap anywhere on the grid',
    instruction3: "The letters will reveal Sri Rama's guidance",
    beginButton: 'Begin',
    gridTitle: "Sri Rama's Guidance",
    gridPrompt: 'Hold your question in mind, and tap any cell',
    resultHeading: "Sri Rama's Guidance",
    collectedLettersAria: 'Collected letters from the path',
    meaningHeading: 'Meaning',
    shareButton: 'Share',
    returnButton: 'Return',
    cooldownMessage: "Traditional practice asks us to reflect on Sri Rama's guidance for one hour",
    cooldownRemaining: 'Next question in {n} minutes',
    cooldownLessThanMinute: 'Next question in less than a minute',
    viewLastReading: 'View your last reading',
    aboutToggleClosed: 'What is Rama Shalaka Prashnavali?',
    aboutToggleOpen: 'Close',
    aboutOrigin: "This tool is based on a tradition from Sri Tulsidas's Ramacharitmanas (~1574 CE).",
    aboutHow: '81 letters are arranged in a 9×9 grid. Each cell is the start of a 9-letter path that spells a verse from the epic.',
    aboutIntention: 'Hold a question in mind, select a cell, and receive the verse as guidance.',
    aboutCulture: 'This tradition is practiced in temples and homes across India as a form of spiritual consultation.',
    shareTitle: "Sri Rama's Guidance",
    shareAlt: 'Share card preview',
    rendering: 'Preparing your reading...',
    shareError: 'Unable to generate image',
    shareNative: 'Share',
    shareSave: 'Save to device',
    shareClose: 'Close',
    tileTitle: 'Rama Shalaka',
    tileDesc: 'Ask Sri Rama a question — 9×9 divination grid from Ramacharitmanas',
    tileCategory: 'Divination & Prashnavali',
  },

  // ─── Ganesha Prashnavali ───
  ganeshaPrashnavali: {
    titleEn: 'Sri Ganesha Prashnavali',
    titleTa: 'Sri Ganesha Prashnavali',
    invitation: "Hold a decision in your heart and seek Ganapathi's guidance",
    instruction1: 'Think of your question with sincerity',
    instruction2: 'Tap any cell in the 8×8 grid',
    instruction3: 'Ganapathi will reveal your answer',
    beginButton: 'Begin',
    gridTitle: "Sri Ganesha's Guidance",
    gridPrompt: 'Hold your question in mind, and tap any cell',
    resultHeading: "Sri Ganesha's Guidance",
    interpretationHeading: "Ganapathi's Message",
    cellLabelEn: 'Cell {n}',
    cellLabelTa: 'Cell {n}',
    remedyHeading: 'Remedy',
    shareButton: 'Share',
    returnButton: 'Return',
    cooldownMessage: "Traditional practice asks us to reflect on Ganapathi's guidance for one hour",
    cooldownRemaining: 'Next question in {n} minutes',
    cooldownLessThanMinute: 'Next question in less than a minute',
    viewLastReading: 'View your last reading',
    aboutToggleClosed: 'What is Ganesha Prashnavali?',
    aboutToggleOpen: 'Close',
    aboutOrigin: 'This tool is based on the Ganesha Purana tradition of divination through 64 cells.',
    aboutHow: '64 cells are arranged in an 8×8 grid. Each cell maps to a specific oracle response with a verse, interpretation, and auspiciousness level.',
    aboutIntention: "Hold a decision in mind, tap a cell, and receive Ganapathi's guidance.",
    aboutCulture: 'Used across Tamil temples as a form of spiritual consultation for yes/no decisions.',
    auspiciousness: {
      highlyFavorable: 'Highly Favorable',
      favorable: 'Favorable',
      neutral: 'Neutral',
      cautionary: 'Cautionary',
      unfavorable: 'Unfavorable',
      aria: 'Auspiciousness: {label}, level {n} of 5',
    },
    shareTitle: "Sri Ganesha's Guidance",
    shareAlt: 'Share card preview',
    rendering: 'Preparing your reading...',
    shareError: 'Unable to generate image',
    shareNative: 'Share',
    shareSave: 'Save to device',
    shareClose: 'Close',
    tileTitle: 'Ganesha Prashnavali',
    tileDesc: 'Ask Ganapathi for guidance — 8×8 oracle grid with auspiciousness reading',
    tileCategory: 'Divination & Prashnavali',
  },

  // ─── Prashnavali shared (share modal) ───
  prashnavali: {
    share: {
      rendering: 'Preparing your reading...',
      error: 'Unable to generate image',
      alt: 'Share card preview',
      shareNative: 'Share',
      save: 'Save to device',
      close: 'Close',
    },
    panchangam: {
      insightHeading: 'Panchangam Insight',
      snapshotHeading: 'Cosmic Moment',
      nakshatra: 'Nakshatra',
      tithi: 'Tithi',
      hora: 'Hora',
      horaSuffix: 'Hora',
      tamilYogam: 'Tamil Yogam',
      activePeriod: 'Active Period',
      muhurtaGreen: 'Auspicious moment for divination',
      muhurtaYellow: 'Neutral moment',
      muhurtaRed: 'Consider waiting',
      muhurtaLoading: 'Reading the moment…',
      pakshaShukla: 'Shukla',
      pakshaKrishna: 'Krishna',
      pakshaSeparator: 'paksha',
      activePeriodNallaNeram: 'Nalla Neram',
      activePeriodRahuKaal: 'Rahu Kaal',
      activePeriodYamagandam: 'Yamagandam',
      activePeriodGulikai: 'Gulikai',
      activePeriodVarjyam: 'Varjyam',
      activePeriodBhadra: 'Bhadra',
      activePeriodPanchaka: 'Panchaka',
      activePeriodSarvarthaSiddhi: 'Sarvartha Siddhi',
      activePeriodAmritSiddhi: 'Amrit Siddhi',
      activePeriodNone: 'None active',
      badgeAriaGreen: 'Panchangam muhurta: green, auspicious',
      badgeAriaYellow: 'Panchangam muhurta: yellow, neutral',
      badgeAriaRed: 'Panchangam muhurta: red, caution',
    },
  },

  // ─── Hanuman Prashnavali ───
  hanumanPrashnavali: {
    titleEn: 'Sri Hanuman Prashnavali',
    titleTa: 'Sri Hanuman Prashnavali',
    invitation: "Hold your challenge in your heart and seek Hanuman's counsel",
    instruction1: 'Think of a challenge you face',
    instruction2: 'Tap any cell in the 7×7 grid',
    instruction3: 'Hanuman will offer counsel for courage',
    beginButton: 'Begin',
    gridTitle: "Hanuman's Counsel",
    gridPrompt: 'Hold your question in mind, and tap any cell',
    resultHeading: "Hanuman's Counsel",
    collectedLettersAria: 'Collected letters from the path',
    interpretationHeading: 'Counsel',
    chalisaLineAttribution: 'Hanuman Chalisa — line {n}',
    shareButton: 'Share',
    returnButton: 'Return',
    shareTitle: "Hanuman's Counsel",
    cooldownMessage: "Traditional practice asks us to reflect on Hanuman's counsel for one hour",
    cooldownRemaining: 'Next question in {n} minutes',
    cooldownLessThanMinute: 'Next question in less than a minute',
    viewLastReading: 'View your last reading',
    specialDayLanding: 'Today is a Hanuman day — blessings are especially potent',
    specialDayResult: "Hanuman's day reading",
    aboutToggleClosed: 'What is Hanuman Prashnavali?',
    aboutToggleOpen: 'Close',
    aboutOrigin: 'This tool is based on the Hanuman Chalisa composed by Sant Tulsidas.',
    aboutHow: '49 cells arranged in a 7×7 grid. Each cell starts a 7-letter path that reveals a verse from the Chalisa.',
    aboutIntention: "Hold your challenge in mind, select a cell, and receive Hanuman's counsel.",
    aboutCulture: 'Tuesdays and Saturdays are traditionally dedicated to Hanuman. Devotees seek strength for challenges on these days.',
    tileTitle: 'Hanuman Prashnavali',
    tileDesc: "Seek Hanuman's counsel for courage — 7×7 path-trace from the Hanuman Chalisa",
    tileCategory: 'Divination & Prashnavali',
  },

  // ─── Chanakya Niti ───
  chanakyaNiti: {
    titleEn: 'Chanakya Niti Prashnavali',
    titleTa: 'Chanakya Niti Prashnavali',
    invitation: 'Hold a question about strategy, governance, or relationships in mind.',
    instruction1: 'Reflect on your question with care',
    instruction2: 'Tap any cell in the 6×6 grid',
    instruction3: "Chanakya's aphorism will offer counsel",
    consultButton: 'Consult',
    gridTitle: 'Select an Aphorism',
    gridPrompt: 'Reflect on your question and tap any cell',
    resultHeading: "Chanakya's Counsel",
    aphorismNumber: 'Aphorism {n}',
    interpretationHeading: 'Meaning',
    shareButton: 'Share',
    returnButton: 'Return',
    shareTitle: "Chanakya's Counsel",
    cooldownMessage: "Traditional practice asks us to reflect on Chanakya's counsel for one hour before consulting again.",
    cooldownRemaining: 'Next consultation in {n} minutes',
    cooldownLessThanMinute: 'Next consultation in less than a minute',
    viewLastReading: 'View your last aphorism',
    aboutToggleClosed: 'Who was Chanakya?',
    aboutToggleOpen: 'Close',
    aboutWho: 'Chanakya (Kautilya) was an ancient Indian scholar, advisor to Chandragupta Maurya (~300 BCE), author of the Arthashastra and Niti Shastra.',
    aboutText: 'The Niti Shastra is a collection of aphorisms on governance, strategy, relationships, and ethics.',
    aboutHow: '36 aphorisms arranged in a 6×6 grid. Each cell maps to one aphorism tagged with a theme.',
    aboutIntention: 'Consult for perspective on decisions, strategy, or relationships. A reflection on classical wisdom.',
    themes: {
      business: 'Business',
      relationships: 'Relationships',
      governance: 'Governance',
      self_discipline: 'Self-Discipline',
      strategy: 'Strategy',
      ethics: 'Ethics',
    },
    themeAriaLabel: 'Theme: {theme}, Aphorism {n}',
    tileTitle: 'Chanakya Niti',
    tileDesc: "Consult Chanakya's aphorisms on strategy and ethics — 6×6 Niti Shastra grid",
    tileCategory: 'Divination & Prashnavali',
  },
};

export default en;
